import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthStore } from "../pages/auth/store/auth.store";
import { PLATFORM_ADMIN_ROLES } from "../pages/auth/model/role.model";
import { DataSyncsService } from '../pages/administration/services/data-syncs.service';
import { map } from 'rxjs';

export const administrationGuard: CanActivateFn = () => {
  if (inject(AuthStore).role() === 'HR') return dataSyncAccess();
  return adminAccess();
};

export const administrationChildGuard: CanActivateFn = route => {
  if (route.routeConfig?.path === 'data-syncs') return dataSyncAccess();
  return adminAccess();
};

function dataSyncAccess() {
  const router = inject(Router);
  return inject(DataSyncsService).checkAccess().pipe(map(result => result.canView || router.createUrlTree(['/home/403-forbidden'])));
}

function adminAccess() {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const activeOrganizationId = authStore.activeOrganizationId();
  const role = authStore.role();

  const canSeeAdministration =
    activeOrganizationId === 1 &&
    role !== undefined &&
    PLATFORM_ADMIN_ROLES.includes(role);

  if (canSeeAdministration) return true;

  return router.createUrlTree(["/home/403-forbidden"]);
}
